<script setup lang="ts">
import api from "@/app/services/apiDas.ts";
import type { AxiosResponse } from "axios";
import type { ApiResponse } from "@/app/types";
import { onMounted, PropType, ref, type Ref, watch } from "vue";
import { AdminUnitsSelection } from "@/domains/home/services/nir/forms/components/widgets/types";

const props = defineProps({
  active: Boolean,
  data: {
    type: Object as PropType<AdminUnitsSelection>,
  },
})
interface AdminUnitResult {
  name: string,
  parent: string,
  id: string,
  parentId: string,
  type: string
  code: string
  children: AdminUnitResult[]
}


const unit: Ref<AdminUnitResult | undefined> = ref()

onMounted(() =>{
  if(props.data && props.data?.villageId){
    fetch()
  }
})

function fetch(){
  return api.get(`/admin-units/${props.data?.villageId}?childrenLevels=7`)
      .then((response: AxiosResponse<ApiResponse<AdminUnitResult>>) => {
        unit.value = response.data.data
      })
}

watch(() => props.data, () =>{
  fetch()
})

</script>

<template>
  <div class="flex flex-col p-3 border border-gray-200 rounded-xl">
    <div class="grid grid-cols-1 gap-3">
      <div v-if="data?.description" class="p-3 border border-gray-200 rounded-lg">
        {{ data?.description }}
      </div>
      <div v-else-if="unit"
           class="flex flex-col bg-white border border-gray-200 p-3 rounded-lg hover:shadow-md transition-shadow cursor-pointer">
        <div class="flex gap-2 border-b border-gray-200">
          <i class="fa fa-map-marker-alt text-primary mt-1"></i>
          <div class="flex gap-2">
            <label class="font-semibold text-gray-900">{{ unit.name }}</label>  <label class="text-xs text-gray-500 mt-1">| {{ unit.type }}</label>
          </div>
        </div>
        <div class="flex pt-2">
          <div class="grid grid-cols-3 gap-2">
            <div class="flex gap-2" v-for="tree in unit.children" :key="tree.id">
              <label class="text-sm text-gray-500">{{ tree.type }}:</label>
              <label class="font-semibold text-sm text-gray-900">{{ tree.name }}</label>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center py-6 text-gray-500">
        No admin units data available
      </div>
    </div>
  </div>
</template>

<style scoped></style>
